import * as actionTypes from '../actions/types';
import License from '../models/License';
import PaginateResponse from '../services/PaginateResponse';

export interface LicenseReducerState {
    readonly data: PaginateResponse<License[]> | null;
    readonly isLoading: boolean;
}

const INITIAL_STATE: LicenseReducerState = {
    data: null,
    isLoading: false,
}

export default (state: any = INITIAL_STATE, action: any) => {
    switch(action.type) {

        case actionTypes.LICENSE_FETCH:
            
            return {
                ...state,
                data: action.payload.data,
                isLoading: false,
            }

        case actionTypes.LICENSE_FETCH_NEXT:

            let actualLicenses: Screen[] = state?.data?.data ?? [];
            let payload: PaginateResponse<License[]> = action.payload.data;
            let newLicenses: any = payload.data ?? [];

            if(action.payload.current_page <= state?.data?.current_page) {
                return {
                    ...state,
                }
            }

            newLicenses = actualLicenses.concat( newLicenses );
            payload.data = newLicenses;

            return {
                ...state,
                data: payload,
                isLoading: false,
            }

        case actionTypes.LICENSE_CHANGE_VALUE:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            }

        default:
            return state;
        
    }
}
